export interface GetActionNameOptions {
  context: string;
  feature: string;
  section: string;
  action: string;
  event: string;
}

export function getActionName({
  context,
  feature,
  section,
  action,
  event,
}: Partial<GetActionNameOptions>): string {
  const unique = new Set();
  const aux = [];
  if (context) {
    unique.add(`[${context.trim()}]`);
  }

  if (feature) {
    unique.add(`[${feature.trim()}]`);
  }

  unique.forEach((x) => {
    aux.push(x);
  });

  if (section) {
    aux.push(`{${section.trim()}}`);
  }

  if (action) {
    aux.push(`${action.trim()}`);
  }

  if (event) {
    aux.push(`(${event.trim()})`);
  }

  const rv = aux.join(' ');
  return rv;
}
